import Vue from 'vue';
import Router from 'vue-router';

import HomePage from '@/components/pages/HomePage.vue';
import IntroductionPage from '@/components/pages/Introduction.vue';
import CalendarPage from '@/components/pages/Calendar.vue';
import LocationsPage from '@/components/pages/Locations.vue';
import ContactsPage from '@/components/pages/Contacts.vue';
import NewslettersPage from '@/components/pages/Newsletters.vue';
import HistoryPage from '@/components/pages/History.vue';
import PreservationPage from '@/components/pages/Preservation.vue';
import MembershipPage from '@/components/pages/Membership.vue';
import PublicationsPage from '@/components/pages/Publications.vue';
import PicturesPage from '@/components/pages/Pictures.vue';
import LinksPage from '@/components/pages/Links.vue';
import OfficersPage from '@/components/pages/Officers.vue';

Vue.use(Router);

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    // {
    //   path: '/',
    //   name: 'homepage',
    //   component: HomePage,
    // },
    {
      path: '/',
      name: 'home',
      component: IntroductionPage,
    },
    {
      path: '/calendar',
      name: 'calendar',
      component: CalendarPage,
    },
    {
      path: '/locations',
      name: 'locations',
      component: LocationsPage,
    },
    {
      path: '/contacts',
      name: 'contacts',
      component: ContactsPage,
    },
    {
      path: '/newsletters',
      name: 'newsletters',
      component: NewslettersPage,
    },
    {
      path: '/history',
      name: 'history',
      component: HistoryPage,
    },
    {
      path: '/preservation',
      name: 'preservation',
      component: PreservationPage,
    },
    {
      path: '/membership',
      name: 'membership',
      component: MembershipPage,
    },
    {
      path: '/publications',
      name: 'publications',
      component: PublicationsPage,
    },
    {
      path: '/pictures',
      name: 'pictures',
      component: PicturesPage,
    },
    {
      path: '/links',
      name: 'links',
      component: LinksPage,
    },
    {
      path: '/officers',
      name: 'officers',
      component: OfficersPage,
    },
  ],
});
